import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import LoadingWheel from "../../components/shared/LoadingWheel";
import usePendingCategorySingle from "../../data/PendingCategory/usePendingCategorySingle";
import PendingCategoryDetails from "../../components/PendingCategoryEditor/PendingCategoryDetails";


export default function EditPendingCategory() {
  const { pendingCategoryId } = useParams();
  const { setInfo } = usePageNameContext();
  const { pendingCategory, update, confirm } = usePendingCategorySingle(pendingCategoryId);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!pendingCategory.isLoading) {
      setIsLoading(false);
    }
  }, [pendingCategory.isLoading, pendingCategory.data]);

  useEffect(() => {
    setInfo({
      name: "Pending Categories",
      desc: "Review and edit before confirming - confirming adds it to your categories",
      pageTitle: "Pending Categories",
    });
  }, []);

  if (isLoading) {
    return <LoadingWheel />;
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <h1 className="text-xl">{pendingCategory.data?.name ?? "Pending Category"}</h1>
      </div>
      <div className="mt-4">
        <PendingCategoryDetails category={pendingCategory.data} update={update} confirm={confirm} />
        <br />
      </div>
    </div>
  );
}
